import { FormClassRetire, FormKbn } from "../../../assets/data/Constants";

/**
 * リクエストのファイルオブジェクトを生成する
 * @param payroll 仮退職年月日以前6ヶ月の給与台帳（写）
 * @param identification 身分証明書（写）
 * @param commission 委任状
 * @param facilityNo 施設番号
 * @param staffNo 職員番号
 * @returns formList
 */
export const makeFormList = (
  payroll: any,
  identification: any,
  commission: any,
  facilityNo: any,
  staffNo: any
) => {
  let formList = [];
  let serialNo = 1;

  payroll?.length &&
    formList.push({
      serialNo: serialNo++,
      facilityNo: facilityNo,
      staffNo: staffNo,
      formKbn: FormKbn["退職書類"],
      formClass: FormClassRetire["仮退職年月日以前6ヶ月の給与台帳（写）"],
      fileName: payroll[0].formName,
      fileBase64: payroll[0].fileBase64,
    });

  identification?.length &&
    formList.push({
      serialNo: serialNo++,
      facilityNo: facilityNo,
      staffNo: staffNo,
      formKbn: FormKbn["退職書類"],
      formClass: FormClassRetire["退職支給証明依頼者の身分証明書（写）"],
      fileName: identification[0].formName,
      fileBase64: identification[0].fileBase64,
    });

  commission?.length &&
    formList.push({
      serialNo: serialNo++,
      facilityNo: facilityNo,
      staffNo: staffNo,
      formKbn: FormKbn["退職書類"],
      formClass: FormClassRetire["退職支給証明依頼の委任状"],
      fileName: commission[0].formName,
      fileBase64: commission[0].fileBase64,
    });

  return formList;
};
